<template>
  <data-section
    style="font-size: 15px"
    theme="blue"
    title="其他人壽保單"
    :isLoading="isLoading"
    :datas="datas"
    :_fields="
      [
        {
          name: '公司/保單號碼\n險種',
          key: 'productname',
          width: 274,
          sortable: true,
          orderByMultiKey: ['sortProductname'],
          orderByMultiType: ['asc']
        },
        {
          name: '要保人',
          key: 'applicant',
          width: 79,
          sortable: true,
          orderByMultiKey: ['sortApplicant'],
          orderByMultiType: ['asc']
        },
        {
          name: '被保人',
          key: 'insuredpersonname',
          width: 79,
          sortable: true,
          orderByMultiKey: ['sortInsuredpersonname'],
          orderByMultiType: ['asc']
        },
        { name: '繳費\n年期', key: 'year', width: 55 },
        {
          name: '承保\n對象',
          key: 'relation',
          width: 49,
          thClassName: 'text-left',
          className: 'text-left'
        },
        {
          name: '投保始期',
          key: 'insurancedate',
          width: 95,
          className: 'text-left',
          sortable: true,
          orderByMultiKey: ['sortInsuranceADDate'],
          orderByMultiType: ['asc']
        },
        {
          name: '保額',
          key: 'amountofinsurance',
          width: 96,
          thClassName: 'text-right',
          className: 'text-right',
         /* sortable: true,
          orderByMultiKey: ['amountofinsurance'],
          orderByMultiType: ['asc'] */
        },
        {
          name: '保費/繳別',
          key: 'bknm',
          width: 138,
          thClassName: 'text-right',
          className: 'text-right',
          sortable: true,
          orderByMultiKey: [
            'sortBknm',
            'isprimarycontract',
            'money',
            'longPremium'
          ],
          orderByMultiType: ['asc', 'adesc', 'asc', 'asc']
        },
        { name: '受益人', key: 'bnf', width: 99 }
      ].concat(_fields)
    "
    @toggle="
      (isShow) => $router.assignQuery({ OtherLifeInsuranceShow: isShow })
    "
    :initShow="$route.query['OtherLifeInsuranceShow'] !== 'false'"
  >
    <template scope="props"  v-if="refresh">
      <data-table
        v-bind="
          Object.assign({}, props, {
            datas: proccessDatas
          })
        "
        @changeSort="
          (sort) =>
            $router.assignQuery({
              [`OtherLifeInsuranceSort`]: JSON.stringify(sort)
            })
        "
        :initSort="
          $route.query[`OtherLifeInsuranceSort`]
            ? JSON.parse($route.query[`OtherLifeInsuranceSort`])
            : null
        "
      >
        <template slot="productname" scope="item">
          <div v-if="item.data.isprimarycontract">
            <div class="font-13">
              {{ `${item.data.companyshortname}/${item.data.policynumber}` }}
            </div>
            <div>
              {{
                item.data.productname.split(" ")[1]
                  ? `${item.data.productname.split(" ")[0]}(${
                      item.data.productname.split(" ")[1]
                    })`
                  : item.data.productname
              }}
              <span v-if="item.data.prodid"> ({{ item.data.prodid }}) </span>
            </div>
          </div>
          <div v-else>
            <div style="margin-left: 1em; text-indent: -1em">
              <span style="text-shadow: 0px 1px grey" class="text-gray">
                <strong>└</strong>
              </span>
              <span style="font-size: 13px">
                {{ `${item.data.companyshortname}/${item.data.policynumber}` }}
              </span>
            </div>
            <div style="margin-left: 1em">
              {{
                item.data.productname.split(" ")[1]
                  ? `${item.data.productname.split(" ")[0]}(${
                      item.data.productname.split(" ")[1]
                    })`
                  : item.data.productname
              }}
              <span v-if="item.data.prodid"> ({{ item.data.prodid }}) </span>
            </div>
          </div>
        </template>
        <template slot="applicant" scope="item">
          <span>
            {{ getFamilyMemberName(item.data.apcid)| truncate }}
          </span>
        </template>
        <template slot="insuredpersonname" scope="item">
          <div>
            {{ item.data.insuredpersonname | truncate }}
          </div>
        </template>
        <template slot="year" scope="item">
          {{ item.data.paymentway == "躉繳" && item.data.producttype == "2" ? "--" : (item.data.year.padLeft(2, "0") + item.data.prd_unit) }}
        </template>
        <template slot="amountofinsurance" scope="item">
          <div
            v-if="item.data.schemename && item.data.quantity"
            class="text-right pre-formatted"
          >
            {{ `計畫${item.data.schemename}：` }}
            {{
              item.data.schemename && item.data.schemename.includes("_1")
                ? ``
                : `日額`
            }}
            {{ `${item.data.quantity}元` }}
          </div>
          <div v-else class="text-right">
            {{ item.data.amountofinsurance }}
          </div>
        </template>
        <template slot="bknm" scope="item">
          <div v-if="item.data.premium">
            {{ item.data.money + ' ' }}{{ item.data.premium }}
          </div>
          <div>{{ item.data.paymentway }}</div>
          <div v-if="item.data.bknm || item.data.card_acnt_no">
            {{ `${item.data.bknm}(${item.data.card_acnt_no})` }}
          </div>
        </template>
        <template slot="bnf" scope="item">
          <div
            v-for="(name, key) in {
              bnf_death_nm: '身故',
              bnf_matag_nm: '滿期',
              bnf_annuity_nm: '年金',
              bnf_birth_nm: '祝壽'
            }"
            :key="key"
          >
            <span
              v-if="item.data[key]"
              :set="(names = item.data[key].split(','))"
            >
              {{ name }}：
              <span v-for="(name, index) in names" :key="index">
                <truncate-tool :content="name"></truncate-tool>
                {{ names.length - 1 > index ? "、" : "" }}
              </span>
            </span>
          </div>
          <div
            v-if="
              !item.data.bnf_death_nm &&
              !item.data.bnf_matag_nm &&
              !item.data.bnf_annuity_nm &&
              !item.data.bnf_birth_nm
            "
          >
            一一
          </div>
        </template>
        <template slot="action" scope="item">
          <div class="dropdown" v-if="item.data.isMyself">
            <a
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              class="btn btn-icon btn-default btn-sm"
              role="button"
            >
              <i class="icon-more"></i>
            </a>
            <div class="dropdown-menu">
              <a
                role="button"
                class="dropdown-item text-green text-underline"
                @click="toUpdate(item.data)"
                >修改</a
              >
              <a
                role="button"
                class="dropdown-item text-green text-underline"
                @click="doDelete(item.data)"
                >刪除</a
              >
              <a
                v-if="item.data.isprimarycontract"
                role="button"
                class="dropdown-item text-green text-underline"
                @click="toAddSubContract(item.data)"
                >新增附約</a
              >
            </div>
          </div>
        </template>
      </data-table>
    </template>
  </data-section>
</template>

<script>
import FamilyMixins from "../common";
import InsuranceMixins from "./Insurance";
import { deleteOtherLifeInsurance } from "@/service";
import TruncateTool from "./TruncateTool";
import { mvCommonMixin } from '@/desktop/views/mv/mixins/common';

const { moment } = window;
export default {
  mixins: [InsuranceMixins, FamilyMixins, mvCommonMixin],
  components: {
    TruncateTool
  },
  methods: {
    toUpdate(data) {
      const MASTER_CONTRACT = "1";
      const QUERY = {
        contract_id: data.contract_id,
        policyid: data.policyid,
        companyid: data.companyid
      };
      const routeTarget =
        data.contract_type == MASTER_CONTRACT
          ? { name: "bk-add-other-comp-contract", query: QUERY }
          : {
              name: "bk-add-other-comp-sub-contract",
              query: {
                ...QUERY,
                csidno: data.csidno,
                rdstdt: data.issue_date
              }
            };
      this.$router.push(routeTarget);
    },
    async doDelete(data) {
      const productName =
        `${data.policynumber} ${data.productname} ` +
        (data.prodid ? `(${data.prodid})` : "");
      const messageBuilder = data.isprimarycontract
        ? this.buildDeleteMessage
        : this.buildDeleteSubMessage;
      await this.$deleteConfirm(messageBuilder(productName));

      await this.deleteSuccessHandler(
        deleteOtherLifeInsurance({
          contract_type: data.contract_type,
          contract_id: data.contract_id,
          policyid: data.policyid,
          source: "BNK",
        })
      );
      this.isLoading = true;
      this.$bus.emit(
        "other-life-insurance.get",
        () => (this.isLoading = false)
      );
    },
    toAddSubContract(data) {
      this.$router.push({
        name: "bk-add-other-comp-sub-contract",
        query: {
          parentContractID: data.contract_id,
          companyid: data.companyid,
          csidno: data.csidno,
          rdstdt: data.issue_date,
          policyid: data.policyid,
          pay_freq: data.pay_freq
        }
      });
    },
  },
  computed: {
    modify() {
      return this.$route.query.modify
        ? this.$route.query.modify.split(",")
        : [];
    },
    proccessDatas() {
      const datas = this.datas
        .map((person) =>
          person.majorpolicyinfolist.map((primary) => {
            const primaryData = primary.policyinfolist[0];
            return primary.policyinfolist.map((data) => {
              return Object.assign({}, data, {
                insuredpersonname: person.insuredpersonname,
                insuredpersonid: person.insuredpersonid,
                companyshortname: primary.companyshortname,
                producttype: primary.producttype,
                policynumber: primary.policynumber,
                applicant: primary.applicant,
                c111_apc : primary.c111_apc,
                apcid: primary.apcid,
                card_acnt_no: primary.card_acnt_no,
                hasprimarycontract: primary.hasprimarycontract,
                bknm: primary.bknm,
                trClassName: this.modify.includes(data.contract_id)
                  ? "bg-orange"
                  : data.isprimarycontract
                  ? "bg-white"
                  : "bg-gray",
                isMyself: data.relation == "本人",
                longPremium: data.premium.padLeft(20, "0"),
                sortProductname: this.mergeString(
                  primaryData.compid.padLeft(5, "0"),
                  primary.policynumber,
                  primary.policyid
                ),
                sortApplicant: this.mergeString(
                  primaryData.applicant,
                  primary.policyid
                ),
                sortInsuredpersonname: this.mergeString(
                  person.insuredpersonname,
                  primary.policyid
                ),
                sortInsuranceADDate: this.mergeString(
                  moment(primaryData.insurancedate).getADDate(),
                  primary.policyid
                ),
                sortBknm: this.mergeString(
                  // 沒有數字可以被放一起
                  !primaryData.premium ? "" : "_",
                  primaryData.money,
                  // 左邊補0讓文字可以被排序
                  primaryData.premium.padLeft(20, "0"),
                  primary.policyid
                )
              });
            });
          })
        )
        .flat()
        .flat();

      const { _ } = window;
      const MASTER_CONTRACT = "1";
      const relationOrder = _.invert(["本人", "配偶", "子女"]);

      const findRelationInDatas = (relation) =>
        _.filter(datas, {
          contract_type: MASTER_CONTRACT,
          relation
        });
      // 本人主約
      const myselfContracts = findRelationInDatas("本人");
      // 配偶主約
      let spouseContracts = findRelationInDatas("配偶");
      // 子女主約
      let sonContracts = findRelationInDatas("子女");

      // 附約
      let subContracts = _.reject(datas, {
        contract_type: MASTER_CONTRACT
      });

      // 取出屬於這張單的內容，"並從原資料中移除"
      const pickBelongContract = (policyid) => (datas) =>
        _.remove(datas, { policyid: policyid });
      return myselfContracts
        .reduce((result, myselfContract) => {
          const pickBelongThisContract = pickBelongContract(
            myselfContract.policyid
          );
          const thisPartContracts = []
              // 這張單的本人主約
              .concat(myselfContract)
              // 屬於這張單的附約
              .concat(
                _.map(
                  _.groupBy(
                    pickBelongThisContract(subContracts),
                    "contract_id"
                  ),
                  (datas) => _.orderBy(datas, (x) => relationOrder[x.relation])
                ).flat()
              )
              // 屬於這張單的配偶主約
              .concat(pickBelongThisContract(spouseContracts))
              // 屬於這張單的子女主約
              .concat(pickBelongThisContract(sonContracts))
              .map(x => ({
                ...x,
                sortInsuredpersonname: this.mergeString(
                  myselfContract.insuredpersonname,
                  myselfContract.policyid
                ),
                sortBknm: this.mergeString(
                  // 沒有數字可以被放一起
                  !myselfContract.premium ? "" : "_",
                  myselfContract.money,
                  // 左邊補0讓文字可以被排序
                  myselfContract.premium.padLeft(20, "0"),
                  myselfContract.policyid
                ),
                sortInsuranceADDate: this.mergeString(
                  moment(myselfContract.insurancedate).getADDate(),
                  myselfContract.policyid
                )
              }))
          return result.concat(thisPartContracts)
        }, [])
        .concat(spouseContracts)
        .concat(sonContracts)
        .concat(subContracts);
    }
  },
  mounted() {}
};
</script>
